import { render, staticRenderFns } from "./addSuggest.vue?vue&type=template&id=7c47e8a2&scoped=true&"
import script from "./addSuggest.vue?vue&type=script&lang=js&"
export * from "./addSuggest.vue?vue&type=script&lang=js&"
import style0 from "./addSuggest.vue?vue&type=style&index=0&id=7c47e8a2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c47e8a2",
  null
  
)

export default component.exports